import React, {useState, useEffect, useRef} from 'react';
import VariantProductRow from './VariantProductRow';
import ViewImageSlider from '../../../common/ViewImage/ViewImageSlider';
import UploadOptions from '../../../common/upload-options/UploadOptions';
import withPortal from 'jd-library/withPortal';
import { connect } from 'react-redux';
import {setVariantProductData} from '../../../actions/variants';
// import ReorderInfo from './ReorderInfo';

const UploadOptionsPortal = withPortal(UploadOptions)

const VariantProductList = (props) => {
    const [imageSlider, setImageSlider] = useState({show: false})
    const [reorderSlider, setReorderSlider] = useState({show: false})
    const oldImageArr = useRef(null);

    useEffect(()=>{
        if(imageSlider.show){
            props.setImageIndex(imageSlider.productIndex)
        }
    },[imageSlider.show])

    const hideError = (key,index) => {
        let variantData = props.productData;
        let varData = [...variantData];
        let errors = {...varData[index].errors};
        errors[key] = '';
        if(varData.length){
            varData[index].errors = errors;
            props.setProductData(varData[index],index);
        }
    }

    return (
        <>
                {props.productData.map((value,index)=>{
                    return(
                        (props.hideProduct && index > 9) ? null : <VariantProductRow 
                            productData={value}
                            productList={props.productData}
                            setMoreDetails={(index, titleStr)=>props.setMoreDetails(index, value, titleStr)}
                            setProductData={props.setProductData}
                            setAllProductData={props.setAllProductData}
                            index={index}
                            isEdit={props.isEdit}
                            variantInfo={props.variantCombinations[index]}
                            setImageIndex={props.setImageIndex}
                            setImageSlider={setImageSlider}
                            setReorderSlider={setReorderSlider}
                            hideError={hideError}
                            uploadOptionProps={{
                                vendorSubMenu: true,
                                isVariant: true,
                                variantId: value.variantId,
                                variantIndex: index,
                                onFileUpload: props.uploadOptionProps.onFileUpload,
                                variantProductData: props.uploadOptionProps.variantProductData 
                            }}
                        />
                    )
                })}
            {imageSlider.show && <ViewImageSlider  
                canUploadImage={true}
                productListViewImageSlider={false}
                onHidden={() => setImageSlider({show: false})}
                imageUrlArr={[...props.productData[imageSlider.productIndex].imageUrlArr, ...props.productData[imageSlider.productIndex].videoUrlArr]}
                hideAddVideo={props.productData[imageSlider.productIndex].videoUrlArr.length > 0}
                deleteProductImage={(res)=>{
                    oldImageArr.current = props.productData[imageSlider.productIndex].imageUrlArr;
                    props.setProductData({
                        ...props.productData[imageSlider.productIndex],
                        imageUrlArr: res.imageUrlArr.filter(obj=>!obj.isVideo)
                    }, imageSlider.productIndex)
                }}
                deleteProductVideo={(res)=>{
                    props.setProductData({
                        ...props.productData[imageSlider.productIndex],
                        videoUrlArr: []
                    }, imageSlider.productIndex, res?.productId)
                }}
                restoreProductData={()=>{
                    props.setProductData({
                        ...props.productData[imageSlider.productIndex],
                        imageUrlArr: oldImageArr.current
                    }, imageSlider.productIndex)
                }}
                hideSaveButton={true}
                showToastMessage={props.showToastMessage}
                imgSuccessMsg={'Image Uploaded Successfully'}
                noImgLabel='Add Image'
                productId={props.productId}
                showUndoToast={true}
                imgUploadUrl={'/marketplace/products/ajax/uploadProductImageForB2B.service?supplierId='+props.permissions.supplierId}
                {...imageSlider}
                uploadOptionProps={{    
                    vendorSubMenu: true,
                    isVariant: true,
                    variantIndex: imageSlider.productIndex,
                    onFileUpload: props.uploadOptionProps.onFileUpload,
                    variantProducts: props.uploadOptionProps.variantProductData
                }}
                videoUrlIds={props.productData[imageSlider.productIndex].videoUrlArr}
            />}
            {/* {reorderSlider.show && <ReorderInfo
                reorderData={{
                    isAutoReorderLevel: props.productData[reorderSlider.index].isAutoReorderLevel,
                    isAutoReorderQuantity: props.productData[reorderSlider.index].isAutoReorderQuantity,
                    reorderLevel: props.productData[reorderSlider.index].reorderLevel,
			        reorderQuantity: props.productData[reorderSlider.index].reorderQuantity
                }}
                onSave={(res)=>{
                    props.setProductData({
                        ...props.productData[reorderSlider.index],
                        ...res
                    }, reorderSlider.index)
                }}
                onHidden={()=>setReorderSlider({show: false})}
            />} */}
            {/* {props.showUploadOptions && <UploadOptionsPortal 
                {...props.uploadOptionProps}
                variantIndex={imageSlider.show ? imageSlider.productIndex : props.uploadOptionProps.variantIndex}
            />} */}
        </>
    )
}

const mapStateToProps = state => {
    return {
        variantData: state.variants.variantProductData,
        productId: state.products.editProduct.productId,
        isService: state.products.editProduct.categoryType == 'service'
    }
}

export default connect(mapStateToProps,{setVariantProductData})(VariantProductList);